import $ from 'jquery';

/* global x5script */

class NewsList {
  init() {
    this.newsList = $('.js-news-list');
    this.loadMoreButton = $('.js-news-list-more-button');
    this.reinit = false;
    this.mainLoader = this.newsList.parent().find('.js-news-list-loader');

    if (!this.newsList.length) {
      return;
    }

    this.masonryInit();
    this.loadMoreNews();
  }

  masonryInit() {
    this.imagesLoaded = false;
    this.loadedImages = [];

    this.items = this.newsList.find('.js-news-item');
    this.thumbnails = this.newsList.find('.js-news-item-image');

    if (this.reinit) {
      this.setMasonry();
      return;
    }

    if (this.thumbnails.length) {
      this.newsList.on('lazyloaded', e => {
        if (this.imagesLoaded) {
          return;
        }

        const imageLoaded = $(e.originalEvent.target);

        if (imageLoaded.hasClass('js-news-item-image')) {
          this.loadedImages.push(1);
        }

        if (this.loadedImages.length === this.thumbnails.length) {
          this.setMasonry();
        }

        // this.imagesLoaded = true;
      });
    } else {
      window.onload = () => {
        this.setMasonry();
      };
    }

    let debouce;
    $(window).on('resize', () => {
      clearTimeout(debouce);

      debouce = setTimeout(() => {
        this.setMasonry();
      }, 400);
    });
  }

  setMasonry() {
    if (!this.items.length) {
      return;
    }

    this.mainLoader.hide();
    this.loadMoreButton.parent().css({ opacity: 1, 'z-index': 1 });
    this.newsList.stop().animate(
      {
        opacity: 1,
      },
      500,
    );

    if (
      this.newsList.hasClass('js-news-list-grid') ||
      $(window).width() < 769
    ) {
      return;
    }

    this.items.each((i, el) => {
      const item = $(el);
      const itemContent = item.find('.js-news-item-inner');
      const gap = 30;
      const rowSpan = Math.ceil((itemContent.outerHeight(true) + gap) / gap);

      item.css({ 'grid-row-end': `span ${rowSpan}` });
    });
  }

  loadMoreNews() {
    if (!this.loadMoreButton.length) {
      return;
    }

    this.isLoading = false;
    this.page = 2;

    this.loadMoreButton.on('click', e => {
      e.preventDefault();

      if (this.isLoading) {
        return;
      }

      const self = $(e.currentTarget);
      this.loader = self.find('.c-loader');
      this.taxonomy = self.data('taxonomy') || '';
      this.term = self.data('term') || 0;

      this.loadNews();
    });
  }

  loadNews() {
    this.loader.show();

    const data = {
      action: 'load_more_news',
      page: this.page,
      taxonomy: this.taxonomy,
      term: this.term,
      security: x5script.security1,
    };

    $.post(x5script.ajaxurl, data, response => {
      if (response.ok) {
        if (response.news.length) {
          this.addNewsToList(response.news);

          if (response.isLastPage) {
            this.loadMoreButton.hide();
          }
        } else {
          this.loader.hide();
        }
      } else {
        this.loadMoreButton.after(
          `<p style="color:#c00;margin-top:5px;">${response.error}</p>`,
        );
      }
    });

    this.isLoading = true;
  }

  addNewsToList(news) {
    this.newsList.css('opacity', 0);

    let html = '';

    news.forEach(post => {
      html += `
        <article id="post-${post.ID}" class="${post.class} is-new">
          <div class="c-news-item__inner js-news-item-inner">
            <span class="c-news-item__date">${post.date}</span>
            <h3 class="c-news-item__title"><a ${post.link_target} href="${
        post.link
      }">${post.title}</a></h3>
      `;

      if (post.thumbnail) {
        html += `<a ${post.link_target} href="${post.link}" tabindex="-1">${
          post.thumbnail
        }</a>`;
      }

      if (post.excerpt) {
        html += `<p class="c-news-item__excerpt">${post.excerpt}</p>`;
      }

      html += `${post.categories}${post.tags}`;

      html += `
          </div>
        </article>`;
    });

    this.reinit = true;
    this.newsList.append(html);
    setTimeout(() => {
      this.masonryInit();
      $(window).trigger('resize');
      this.loader.hide();
      this.isLoading = false;
      this.page += 1;
    }, 200);
  }
}

export default NewsList;



// WEBPACK FOOTER //
// ./src/scripts/modules/news-list.js